import React from 'react';
import Carousel from '../Carousel';
import NewsCard from '../NewsCard';
import NewsCardProps from '../NewsCard/type';
import { Link } from '../../core/typings';
import './styles.scss';

interface NewsCarouselProps {
  news: NewsCardProps[];
  slickConfig?: Record<string, any>;
  viewMoreLink?: Link;
  title?: string;
}

const NewsCarousel = ({
  news,
  slickConfig,
  viewMoreLink,
  title,
}: NewsCarouselProps) => {
  const defaultSlickConfig = {
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 460,
        settings: {
          slidesToShow: 1.1,
          arrows: true,
        },
      },
    ],
    ...slickConfig,
  };

  return (
    <Carousel
      slickConfig={defaultSlickConfig}
      viewMoreLink={viewMoreLink}
      title={title}
    >
      {news.map((item) => (
        <div key={item.id} className="news-carousel__item">
          <div className="news-carousel__item-container">
            <NewsCard {...item} />
          </div>
        </div>
      ))}
    </Carousel>
  );
};

export default NewsCarousel;
